import { gql } from "@apollo/client";

export const GET_PRODUCT_COLLECTION = gql`
	query GetVariants {
		collections {
			nodes {
				name
				description
				id
				imageSrc
			}
		}
	}
`;
